import { ViewVariants } from './types';

export const getViewVariant = ({
  rest,
  baseRest,
  size,
  isUnlimited = false,
  isGifted = false,
}: {
  baseRest?: number;
  isGifted?: boolean;
  isUnlimited?: boolean;
  rest?: null | number;
  size?: number;
}): ViewVariants => {
  const normalizedRest = rest ?? 0;

  if (isGifted) {
    return 'gifted';
  }

  if (isUnlimited) {
    return 'unlimited';
  }

  if (typeof size === 'number') {
    return 'rest-and-size';
  }

  if (normalizedRest === 0 && typeof baseRest === 'number') {
    return 'pricePerUnit';
  }

  return 'rest-only';
};
